import { render, staticRenderFns } from "./DataStatusDisplay.vue?vue&type=template&id=04264c8f&"
import script from "./DataStatusDisplay.vue?vue&type=script&lang=js&"
export * from "./DataStatusDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DataStatusDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports